<template>
  <footer id="contact" class="foot">
    <div class="panel" ref="panel">
      <span class="panel-bg" ref="bg" aria-hidden="true"></span>
      <div class="cols">
        <div class="col">
          <a href="#solutions" class="head">Next Gen</a>
          <div class="phones mono">
            <a href="https://wa.me/919740639892" target="_blank" rel="noopener noreferrer">+91 97406 39892</a>
            <a href="tel:+919741285885">+91 97412 85885</a>
          </div>
          <address class="mono">
            NEXXT GEN COMPUTERS<br>
            #59, OPP BANK OF INDIA,<br>
            SAHAKARNAGAR, 60 FEET MAIN ROAD,<br>
            BENGALURU, KA - 560092
          </address>
        </div>
        <div class="col">
          <a href="#solutions" class="head">Repairs<sup>4</sup></a>
          <a href="#solutions" v-for="r in repairs" :key="r"><span>↳</span> {{ r }}</a>
        </div>
        <div class="col">
          <span class="head">Company<sup>3</sup></span>
          <a href="#about"><span>↳</span> About Us</a>
          <a href="#reviews"><span>↳</span> Reviews</a>
          <a href="#contact">Contact</a>
        </div>
      </div>

      <h2 class="wordmark display"><span class="wm-solid">NEXXT</span><span class="wm-outline">GEN</span></h2>
    </div>

    <div class="legal mono">
      <span>© {{ year }} NEXXT GEN COMPUTERS</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      year: new Date().getFullYear(),
      repairs: ['Laptop Service', 'Screen Replacement', 'Hardware Upgrade', 'Data Recovery']
    }
  },
  mounted() {
    const bg = this.$refs.bg
    // Slide-up reveal: toggle on viewport intersection (decoupled from ScrollSmoother).
    this.io = new IntersectionObserver((entries) => {
      bg.classList.toggle('in', entries[0].isIntersecting)
    }, { threshold: 0.25 })
    this.io.observe(this.$refs.panel)
  },
  beforeUnmount() {
    if (this.io) this.io.disconnect()
  }
}
</script>

<style scoped>
.foot { background: var(--coral); padding: 26px 26px 12px; }
.panel {
  color: var(--coral);
  border-radius: 18px; padding: clamp(24px, 3vw, 40px) clamp(40px, 5vw, 70px) clamp(40px, 5vw, 70px);
  position: relative; isolation: isolate;
}
/* black fill layer — rounded rectangle that slides up from the bottom on reveal */
.panel-bg {
  position: absolute; inset: 0; z-index: -1;
  background: #1e1e1e; border-radius: 18px;
  transform: scaleY(0); transform-origin: bottom;
  transition: transform 1.1s cubic-bezier(0.16, 1, 0.3, 1);
}
.panel-bg.in { transform: scaleY(1); }
.cols { display: grid; grid-template-columns: repeat(3, 1fr); gap: 30px; }
.col { display: flex; flex-direction: column; gap: 0; }
.head {
  font-family: var(--font-display); font-weight: 600;
  font-size: clamp(22px, 2.4vw, 34px); color: var(--coral); text-decoration: none;
  margin-bottom: 6px;
}
.head sup { font-size: 0.5em; }
.col a:not(.head) {
  font-family: var(--font-display); font-weight: 500;
  font-size: clamp(15px, 1.4vw, 20px); color: var(--coral); text-decoration: none;
  line-height: 1.15;
  transition: color 0.25s, padding-left 0.25s;
}
.col a span { opacity: 0.5; margin-right: 6px; }
.col a:hover { color: #fff; padding-left: 6px; }

.loc { display: flex; gap: 14px; align-items: flex-start; margin-top: clamp(24px, 3vw, 40px); }
.pin { font-size: 22px; filter: grayscale(0.2); }
.loc p { font-size: 12px; letter-spacing: 1px; line-height: 1.5; margin: 0; }
.phones { display: flex; flex-direction: column; gap: 4px; margin-top: clamp(24px, 3vw, 40px); }
.phones a { font-size: 13px; letter-spacing: 1px; color: var(--coral); text-decoration: none; }
.phones a:hover { color: #fff; }
address { font-style: normal; font-size: 12px; letter-spacing: 1px; line-height: 1.7; text-align: left; margin-top: 16px; }

.wordmark {
  font-size: clamp(70px, 17vw, 260px);
  margin: clamp(20px, 3vw, 40px) 0 0; text-align: center;
  line-height: 0.8; letter-spacing: -4px;
  padding-top: clamp(28px, 4vw, 56px);
  border-top: 1px solid rgba(230, 126, 91, 0.28);
}
.wm-solid { color: var(--coral); }
.wm-outline {
  color: transparent;
  -webkit-text-stroke: 2px var(--coral);
}

.legal {
  display: flex; justify-content: center; flex-wrap: wrap; gap: 16px;
  padding: 12px 6px 2px; font-size: 11px; letter-spacing: 1.5px; color: var(--ink);
}
.legal a { color: var(--ink); text-decoration: none; }
@media (max-width: 760px) {
  .cols { grid-template-columns: 1fr; }
  .legal { flex-direction: column; gap: 8px; text-align: center; }
  address { text-align: left; }
  /* shrink the wordmark so NEXXTGEN fits the viewport, kept centred */
  .wordmark {
    font-size: 14.5vw; letter-spacing: -2px;
    padding-top: clamp(20px, 5vw, 32px); margin-top: clamp(16px, 4vw, 28px);
  }
  .wm-outline { -webkit-text-stroke-width: 1.2px; }
}
</style>
